var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDamagedFile = function SvgDamagedFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 9H14.5V4H5.5V11.857L7 13.25L10.5 9.5L13.5 14.5L15.5 12L18.5 15L15.5 14.5L13.5 17L10.5 13L7.5 16.5L5.5 15.25V20H19.5V9ZM21.5 8V20.993C21.5009 21.1243 21.476 21.2545 21.4266 21.3762C21.3772 21.4979 21.3043 21.6087 21.2121 21.7022C21.1199 21.7957 21.0101 21.8701 20.8892 21.9212C20.7682 21.9723 20.6383 21.9991 20.507 22H4.493C4.22981 22 3.97739 21.8955 3.7912 21.7095C3.605 21.5235 3.50027 21.2712 3.5 21.008V2.992C3.5 2.455 3.949 2 4.502 2H15.497L21.5 8Z",
    fill: "#E56C6C"
  })));
};
export default SvgDamagedFile;